import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';

export default function UploadCorrectionDialog({ open, handleClose, handleUpload, fixedFileType, title, description }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileType, setFileType] = useState(fixedFileType || 71);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const maxFileSize = 2 * 1024 * 1024; // 2 MB
            if (file.size > maxFileSize) {
                alert("Plik jest za duży. Maksymalny rozmiar to 2 MB.");
                return;
            }
            setSelectedFile(file);
        }
    };

    const handleConfirm = () => {
        if (selectedFile) {
            handleUpload(selectedFile, fixedFileType || fileType);
            setSelectedFile(null);
            setFileType(fixedFileType || 71);
        }
    };

    const handleCancel = () => {
        setSelectedFile(null);
        setFileType(fixedFileType || 71);
        handleClose();
    };

    return (
        <Dialog open={open} onClose={handleCancel} fullWidth maxWidth="xs">
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title || 'Wgrywanie faktury korygującej'}</DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} sx={{ mt: 1 }}>
                    <Typography variant="body2" color="textSecondary">
                        {description || 'Wybierz plik faktury korygującej z dysku (np. PDF, maks. 2 MB).'}
                    </Typography>

                    {!fixedFileType && (
                        <FormControl component="fieldset">
                            <FormLabel component="legend" sx={{ fontWeight: 'medium', mb: 0.5, color: 'text.primary', fontSize: '0.9rem' }}>
                                Czego dotyczy korekta?
                            </FormLabel>
                            <RadioGroup
                                value={fileType}
                                onChange={(e) => setFileType(Number(e.target.value))}
                                row={false}
                            >
                                <FormControlLabel value={71} control={<Radio size="small" />} label="Prac dodatkowych" />
                                <FormControlLabel value={81} control={<Radio size="small" />} label="Zestawienia / blokady" />
                            </RadioGroup>
                        </FormControl>
                    )}

                    <Button
                        variant="outlined"
                        component="label"
                        sx={{ textTransform: 'none', borderStyle: 'dashed', py: 2 }}
                    >
                        {selectedFile ? selectedFile.name : "Wybierz plik..."}
                        <input
                            type="file"
                            hidden
                            accept=".pdf,.png,.jpg,.jpeg,.zip"
                            onChange={handleFileChange}
                        />
                    </Button>
                    {selectedFile && (
                        <Typography variant="caption" color="textSecondary" align="center">
                            Rozmiar: {(selectedFile.size / 1024).toFixed(1)} KB
                        </Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={handleCancel} color="secondary" variant="outlined">
                    Anuluj
                </Button>
                <Button
                    onClick={handleConfirm}
                    color="primary"
                    variant="contained"
                    disabled={!selectedFile}
                >
                    Wyślij
                </Button>
            </DialogActions>
        </Dialog>
    );
}
